const POWER_REVIEWS_ROOT_SELECTOR =
  '#PowerReviewsPDP, #PowerReviewsPDPMobile, #PowerReviewsDisplayRoot, #PowerReviewsSnapshot, #PowerReviewsList, #PowerReviewsImageDisplay, #PowerReviewDisplay';

const POWER_REVIEWS_MSQ_LABELS = {
  sizerating: 'Size',
  sizing: 'Size',
  size: 'Size',
  width: 'Width',
  widthrating: 'Width',
  comfort: 'Comfort',
  comfortrating: 'Comfort',
  comfortablerating: 'Comfort',
  comfortability: 'Comfort',
};

const POWER_REVIEWS_FIT_KEYS = ['Size', 'Width', 'Comfort'];

function getPowerReviewsCopy() {
  const isFr = window.theme?.locale === 'fr_CA';
  return {
    fitRating: isFr ? 'Évaluation de la taille' : 'Fit Rating',
    recommendedBy: (percent) =>
      isFr
        ? `Recommandé par ${percent} % des clients`
        : `Recommended By ${percent}% Of Customers`,
    reviewsTitle: (rating, count) =>
      isFr
        ? `Avis ${rating} ★ (${count})`
        : `Reviews ${rating} ★ (${count})`,
    fitsSmall: isFr
      ? 'Cet article taille petit'
      : 'This item fits small',
    fitsTrue: isFr
      ? 'Cet article taille correctement'
      : 'This item fits true to size',
    fitsLarge: isFr
      ? 'Cet article taille grand'
      : 'This item fits large',
    size: isFr ? 'Taille' : 'Size',
    width: isFr ? 'Largeur' : 'Width',
    comfort: isFr ? 'Confort' : 'Comfort',
  };
}

function normalizePowerReviewsFitLabel(rawLabel, idKey = '') {
  const source = `${rawLabel || ''} ${idKey || ''}`.toLowerCase();
  const compact = source.replace(/[^a-z0-9]/g, '');
  const copy = getPowerReviewsCopy();

  if (
    POWER_REVIEWS_MSQ_LABELS[compact] === 'Size' ||
    /\bsize\b|\bsizing\b/.test(source)
  ) {
    return copy.size;
  }
  if (
    POWER_REVIEWS_MSQ_LABELS[compact] === 'Width' ||
    /\bwidth\b|\bnarrow\b|\bwide\b/.test(source)
  ) {
    return copy.width;
  }
  if (
    POWER_REVIEWS_MSQ_LABELS[compact] === 'Comfort' ||
    /\bcomfort\b/.test(source)
  ) {
    return copy.comfort;
  }

  if (POWER_REVIEWS_MSQ_LABELS[compact]) {
    return POWER_REVIEWS_MSQ_LABELS[compact];
  }

  return String(rawLabel || idKey || '')
    .replace(/^msq-histogram-/i, '')
    .replace(/\s*rating\s*/gi, ' ')
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

function humanizePowerReviewsMsqKey(key) {
  return normalizePowerReviewsFitLabel('', key);
}

function readPowerReviewsMsqValue(msqRoot) {
  if (!msqRoot) return '';

  const candidates = [
    msqRoot.querySelector('.pr-slider.pr-text-above'),
    msqRoot.querySelector('.pr-size-fit_slider_node--active'),
    msqRoot.querySelector('.pr-slider-node.pr-active'),
    msqRoot.querySelector('.pr-subrating-text'),
    msqRoot.querySelector('[aria-label]'),
  ].filter(Boolean);

  for (const node of candidates) {
    const value = (
      node.getAttribute('aria-label') ||
      node.textContent ||
      ''
    )
      .replace(/\s+/g, ' ')
      .trim();
    if (value) return value;
  }

  return '';
}

function addFitAttributeVote(buckets, label, value, idKey = '') {
  const normalizedLabel = normalizePowerReviewsFitLabel(label, idKey);
  const cleanValue = String(value || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!normalizedLabel || !cleanValue) return;
  if (!POWER_REVIEWS_FIT_KEYS.includes(normalizedLabel) && !/^(Size|Width|Comfort|Taille|Largeur|Confort)$/i.test(normalizedLabel)) {
    // Still keep Size/Width/Comfort family only for the JD US card.
    const key = normalizedLabel.toLowerCase();
    if (!['size', 'width', 'comfort', 'taille', 'largeur', 'confort'].includes(key)) {
      return;
    }
  }

  if (!buckets[normalizedLabel]) buckets[normalizedLabel] = {};
  buckets[normalizedLabel][cleanValue] =
    (buckets[normalizedLabel][cleanValue] || 0) + 1;
}

function pickModeFromVotes(votes) {
  let bestValue = '';
  let bestCount = 0;
  Object.entries(votes).forEach(([value, count]) => {
    if (count > bestCount) {
      bestCount = count;
      bestValue = value;
    }
  });
  return bestValue;
}

function collectFitAttributesFromMsqHistograms(root, buckets) {
  if (!root) return;

  const nodes = root.querySelectorAll(
    [
      '[id^="msq-histogram-"]',
      '[id*="sizerating"]',
      '[id*="widthrating"]',
      '[id*="comfortrating"]',
      '[id*="sizing"]',
      '.pr-histogram-msqs > *',
      '.pr-review-snapshot-msqs > *',
      '.pr-review-snapshot-histogram-msq-container',
      '.pr-review-snapshot-msq-container',
      '.pr-size-fit',
    ].join(', ')
  );

  nodes.forEach((msqRoot) => {
    const idKey = (msqRoot.id || '').replace(/^msq-histogram-/i, '');
    const headline =
      msqRoot.querySelector(
        '.pr-histogram-msq-headline, .pr-accessible-label, .pr-size-fit_label, .pr-subrating-text, h3, h4, legend'
      )?.textContent || '';
    const label = headline || humanizePowerReviewsMsqKey(idKey);
    const value = readPowerReviewsMsqValue(msqRoot);
    addFitAttributeVote(buckets, label, value, idKey);
  });
}

function collectFitAttributesFromSubratings(root, buckets) {
  if (!root) return;

  root
    .querySelectorAll(
      '.pr-rd-subratings > *, .pr-review-snapshot-subratings > *, .pr-subrating-wrapper, .pr-msq-list > *, .pr-rd-details li, .pr-rd-details > *'
    )
    .forEach((row) => {
      const text = row.textContent?.replace(/\s+/g, ' ').trim() || '';
      if (!text) return;

      const match = text.match(
        /^(Size(?:\s*Rating)?|Width(?:\s*Rating)?|Comfort(?:\s*Rating)?|Sizing|Taille|Largeur|Confort)\s*[:\-]?\s*(.+)$/i
      );
      if (match) {
        addFitAttributeVote(buckets, match[1], match[2]);
        return;
      }

      const labelNode =
        row.querySelector(
          '.pr-histogram-msq-headline, .pr-subrating-label, .pr-accessible-label, dt, strong, b'
        ) || row.firstElementChild;
      const valueNode =
        row.querySelector(
          '.pr-slider.pr-text-above, .pr-subrating-text, .pr-slider-node.pr-active, dd, [aria-label]'
        ) || row.lastElementChild;

      const label = labelNode?.textContent || '';
      const value =
        valueNode?.getAttribute?.('aria-label') ||
        valueNode?.textContent ||
        '';
      if (label && value && label !== value) {
        addFitAttributeVote(buckets, label, value);
      }
    });
}

function collectPowerReviewsFitAttributes(displayRoot) {
  const root =
    displayRoot ||
    getPowerReviewsDisplayRoot() ||
    document.getElementById('PowerReviewsList');
  if (!root) return [];

  const buckets = {};
  collectFitAttributesFromMsqHistograms(root, buckets);
  collectFitAttributesFromSubratings(root, buckets);

  // Also scan the list — Width/Comfort often appear on individual reviews
  // even when the snapshot only renders Size Rating.
  const listRoot = document.getElementById('PowerReviewsList');
  if (listRoot && listRoot !== root) {
    collectFitAttributesFromMsqHistograms(listRoot, buckets);
    collectFitAttributesFromSubratings(listRoot, buckets);
  }

  const copy = getPowerReviewsCopy();
  const preferredOrder = [copy.size, copy.width, copy.comfort];
  const attributes = [];

  preferredOrder.forEach((label) => {
    if (!buckets[label]) return;
    const value = pickModeFromVotes(buckets[label]);
    if (!value) return;
    attributes.push({ label, value, idKey: label.toLowerCase() });
    delete buckets[label];
  });

  // Any remaining fit-related attrs (fallback).
  Object.keys(buckets).forEach((label) => {
    const value = pickModeFromVotes(buckets[label]);
    if (!value) return;
    attributes.push({ label, value, idKey: label.toLowerCase() });
  });

  return attributes;
}

function collectPowerReviewsRecommendationPercent(displayRoot) {
  const root =
    displayRoot ||
    getPowerReviewsDisplayRoot() ||
    document.getElementById('PowerReviewsList');
  if (!root) return null;

  const recoNode =
    root.querySelector('.pr-snippet-reco-to-friend-percent') ||
    root.querySelector('.pr-reco-value') ||
    root.querySelector('.pr-reco-to-friend-message') ||
    document.querySelector(
      '#PowerReviewsSnapshot .pr-snippet-reco-to-friend-percent, #PowerReviewsSnapshot .pr-reco-value, #PowerReviewsSnapshot .pr-reco-to-friend-message'
    );
  if (!recoNode) return null;

  const match = recoNode.textContent?.match(/(\d+)\s*%/);
  return match ? match[1] : null;
}

function updateProductFormFitSuggestion(attributes, productType) {
  if (productType !== 'Footwear' && productType !== 'Apparel') return;

  const sizeAttr = attributes.find((attr) =>
    /size|sizing|sizerating/i.test(`${attr.label} ${attr.idKey || ''}`)
  );
  if (!sizeAttr?.value) return;

  const copy = getPowerReviewsCopy();
  const actualValue = sizeAttr.value.toLowerCase();
  let message = '';

  if (actualValue.includes('small')) {
    message = copy.fitsSmall;
  } else if (
    actualValue.includes('just right') ||
    actualValue.includes('true to size')
  ) {
    message = copy.fitsTrue;
  } else if (actualValue.includes('big') || actualValue.includes('large')) {
    message = copy.fitsLarge;
  }

  if (!message) return;

  document.querySelectorAll('.product-form__fit').forEach((item) => {
    item.innerHTML = `<span class="icon-sug">!</span><span>${message}</span>`;
  });
}

function getPowerReviewsDisplayRoot() {
  return (
    document.getElementById('PowerReviewsDisplayRoot') ||
    document.getElementById('PowerReviewsSnapshot') ||
    document.getElementById('PowerReviewDisplay')
  );
}

function getPowerReviewsSnapshotRoot() {
  return (
    document.getElementById('PowerReviewsSnapshot') ||
    document.getElementById('PowerReviewDisplay') ||
    getPowerReviewsDisplayRoot()
  );
}

function updateReviewsAccordionTitle(data) {
  const titleEl = getPowerReviewsDisplayRoot()
    ?.closest('.product__accordion')
    ?.querySelector('.accordion__title');
  if (!titleEl || data == null) return;

  const count = data.review_count ?? data.reviews ?? data.total_reviews;
  const rating =
    data.average_rating ?? data.avg_rating ?? data.rolling_average;
  if (count == null || rating == null) return;

  const formattedRating = Number(rating).toFixed(1);
  titleEl.textContent = getPowerReviewsCopy().reviewsTitle(
    formattedRating,
    count
  );
}

/**
 * Builds JD US-style fit summary from PowerReviews MSQ / reco DOM.
 * Pulls Size, Width, and Comfort from snapshot histograms and review details.
 */
function mountPowerReviewsFitRating(snapshotRoot, productType) {
  const displayRoot =
    getPowerReviewsDisplayRoot() ||
    snapshotRoot ||
    document.getElementById('PowerReviewsList');
  if (!displayRoot) return;

  const attributes = collectPowerReviewsFitAttributes(displayRoot);
  const recoPercent = collectPowerReviewsRecommendationPercent(displayRoot);

  updateProductFormFitSuggestion(attributes, productType);

  if (!attributes.length && recoPercent == null) return;

  const copy = getPowerReviewsCopy();
  let host = document.getElementById('PowerReviewsFitRating');

  if (!host) {
    host = document.createElement('div');
    host.id = 'PowerReviewsFitRating';

    const listRoot = document.getElementById('PowerReviewsList');
    if (listRoot?.parentNode) {
      listRoot.parentNode.insertBefore(host, listRoot);
    } else if (snapshotRoot?.after) {
      snapshotRoot.after(host);
    } else {
      displayRoot.appendChild(host);
    }
  }

  const attrsHtml = attributes
    .map(
      (attr) => `
      <div class="jd-fit-rating__attr">
        <span class="jd-fit-rating__label">${attr.label}</span>
        <span class="jd-fit-rating__value">${attr.value}</span>
      </div>`
    )
    .join('');

  host.innerHTML = `
    <div class="jd-fit-rating">
      <h3 class="jd-fit-rating__heading">${copy.fitRating}</h3>
      <div class="jd-fit-rating__card">
        ${
          attributes.length
            ? `<div class="jd-fit-rating__attrs" style="--jd-fit-cols: ${attributes.length}">${attrsHtml}</div>`
            : ''
        }
        ${
          recoPercent != null
            ? `<div class="jd-fit-rating__reco">${copy.recommendedBy(
                recoPercent
              )}</div>`
            : ''
        }
      </div>
    </div>
  `;

  host.hidden = false;
  host.removeAttribute('aria-hidden');
  host.classList.remove('power-reviews-slot--hidden');

  snapshotRoot?.classList.add('jd-fit-rating--ready');
  displayRoot.classList.add('jd-fit-rating--ready');
}

/**
 * When a product has zero reviews, hide empty PR modules that create layout gaps.
 * Keep ReviewList visible — PowerReviews places the "Write the First Review" CTA there.
 */
function syncPowerReviewsEmptyState(data) {
  const root = getPowerReviewsDisplayRoot();
  if (!root) return;

  const count = Number(
    data?.review_count ?? data?.reviews ?? data?.total_reviews
  );
  const listRoot = document.getElementById('PowerReviewsList');
  const snapshot = getPowerReviewsSnapshotRoot();
  const writeReviewInList = Boolean(
    listRoot?.querySelector('a.pr-snippet-write-review-link')
  );
  const writeReviewInSnapshot = Boolean(
    snapshot?.querySelector('a.pr-snippet-write-review-link')
  );
  const hasNoReviewsMarkup = Boolean(
    listRoot?.querySelector('.pr-rd-no-reviews, .pr-no-reviews') ||
      snapshot?.querySelector('.pr-rd-no-reviews, .pr-no-reviews') ||
      root.querySelector('.pr-rd-no-reviews, .pr-no-reviews') ||
      writeReviewInList ||
      writeReviewInSnapshot
  );
  const hasReviewItems = Boolean(
    root.querySelector(
      '.pr-review, .pr-rd-content-block, [class*="pr-rd-review-headline"]'
    )
  );
  const isEmpty =
    (Number.isFinite(count) && count === 0) ||
    (hasNoReviewsMarkup && !hasReviewItems && !(Number.isFinite(count) && count > 0));

  root.classList.toggle('power-reviews-display--empty', isEmpty);

  const hideIds = [
    'PowerReviewsAISummary',
    'PowerReviewsImageDisplay',
    'PowerReviewsFitRating',
  ];

  // Hide empty snapshot only when the write CTA lives in the list.
  if (!(isEmpty && writeReviewInSnapshot && !writeReviewInList)) {
    hideIds.push('PowerReviewsSnapshot');
  }

  hideIds.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.hidden = isEmpty;
    el.toggleAttribute('aria-hidden', isEmpty);
    el.classList.toggle('power-reviews-slot--hidden', isEmpty);
  });

  if (listRoot) {
    listRoot.hidden = false;
    listRoot.removeAttribute('aria-hidden');
    listRoot.classList.remove('power-reviews-slot--hidden');
  }

  syncPowerReviewsEmptyPwrSlots();
}

/**
 * Collapse AI Summary / Image Display / Snapshot when their .p-w-r wrapper
 * mounted but has no content (avoids flex gap / white space).
 */
function syncPowerReviewsEmptyPwrSlots() {
  [
    'PowerReviewsAISummary',
    'PowerReviewsImageDisplay',
    'PowerReviewsSnapshot',
  ].forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    // Fully-hidden empty-review state already covers these.
    if (el.classList.contains('power-reviews-slot--hidden') || el.hidden) {
      return;
    }

    const pwr = el.querySelector('.p-w-r');
    const isEmpty =
      !pwr ||
      (pwr.childElementCount === 0 &&
        !String(pwr.textContent || '').trim());

    el.classList.toggle('power-reviews-slot--collapsed', isEmpty);
  });
}

/**
 * PowerReviews often prevents default on "Write a review" and opens a modal.
 * Intercept clicks in capture phase so the browser follows the wrapper URL instead.
 */
function getPowerReviewsPageIdFromWriteReviewAnchor(anchor) {
  if (!anchor?.href) return null;
  try {
    const url = new URL(anchor.href, location.href);
    const id = url.searchParams.get('pr_page_id');
    return id || null;
  } catch {
    return null;
  }
}

function getPowerReviewsPdpPageId(anchor) {
  const productInfo =
    anchor?.closest?.('product-info') ??
    document.querySelector('product-info');
  const script = productInfo?.querySelector('script[data-product-info]');
  if (!script?.textContent) {
    return null;
  }
  try {
    return JSON.parse(script.textContent).id;
  } catch {
    return null;
  }
}

/**
 * Send shoppers to the theme write-a-review page. Prefer `pr_page_id` from the
 * link href (matches PowerReviews after variant/color updates); fall back to
 * script[data-product-info] on product-info.
 */
function resolvePowerReviewsWriteReviewUrl(anchor) {
  const hrefId = getPowerReviewsPageIdFromWriteReviewAnchor(anchor);
  const scriptId = getPowerReviewsPdpPageId(anchor);
  const pageId =
    hrefId != null && String(hrefId).length > 0 ? hrefId : scriptId;
  if (pageId == null || pageId === '') {
    return null;
  }
  const localePrefix = window.theme?.locale === 'fr_CA' ? '/fr' : '';
  return `${location.origin}${localePrefix}/pages/write-a-review/?pr_page_id=${pageId}`;
}

function installPowerReviewsWriteReviewPageRedirect() {
  if (
    typeof window === 'undefined' ||
    window.__powerReviewsWriteReviewPageRedirect
  ) {
    return;
  }
  window.__powerReviewsWriteReviewPageRedirect = true;

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target.closest('a.pr-snippet-write-review-link');
      if (!anchor || !anchor.closest(POWER_REVIEWS_ROOT_SELECTOR)) {
        return;
      }

      const targetUrl = resolvePowerReviewsWriteReviewUrl(anchor);
      if (!targetUrl) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
    },
    true
  );
}

installPowerReviewsWriteReviewPageRedirect();

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.productInfo = JSON.parse(
          this.querySelector('script[data-product-info]')?.textContent
        );

        this.quantityInput = this.querySelector('.quantity__input');

        this.reviews = this.querySelector('#PowerReviewsPDP');

        if (this.reviews) {
          try {
            this.initializeReviews();
          } catch (error) {
            console.error(
              '[product-info] constructor: initializeReviews failed',
              error
            );
          }
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onGroupChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.swatchChange,
          this.handleGroupSwatchChange.bind(this)
        );

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.onVariantUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const data = event.data;

            if (data.sectionId === this.sectionId && data.variant) {
              if (window.theme.dynamic_yield_enabled && DynamicYield) {
                DynamicYield.updateRecomendationContext(data.variant.sku);
              }
            }
          }
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent('product-info:loaded', { bubbles: true })
        );
      }

      initializeReviews() {
        const variantsData = [];

        this.productInfo.variants.forEach((variant) => {
          variantsData.push({
            name: variant.name,
            description: this.productInfo.title,
            page_id_variant: variant.id,
            upc: variant.barcode,
          });
        });

        const productType = this.productInfo.type;
        const reviewsLocalePrefix =
          window.theme?.locale === 'fr_CA' ? '/fr' : '';
        const reviewWrapperUrl = `${location.origin}${reviewsLocalePrefix}/pages/write-a-review/?pr_page_id=${this.productInfo.id}`;

        if (window.pwr) {
          pwr('render', {
            api_key: window.theme.reviews.api_key,
            locale: window.theme.reviews.locale,
            merchant_group_id: window.theme.reviews.group_id,
            merchant_id: window.theme.reviews.merchant_id,
            page_id: this.productInfo.id,
            review_wrapper_url: reviewWrapperUrl,
            on_back_to_top_click: function () {
              var target = document.querySelector('.pr-rid-tile-image');
              target.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              });
            },
            on_render: function (config, data) {
              const snapshotRoot = getPowerReviewsSnapshotRoot();
              const runPostRender = () => {
                if (data?.review_count !== undefined) {
                  updateReviewsAccordionTitle(data);
                }
                syncPowerReviewsEmptyState(data);
                syncPowerReviewsEmptyPwrSlots();
                if (
                  data?.review_count === undefined ||
                  Number(data.review_count) > 0
                ) {
                  mountPowerReviewsFitRating(snapshotRoot, productType);
                }
              };

              runPostRender();
              // Review list (Width/Comfort on individual reviews) can paint after
              // the first on_render tick — remount once content is available.
              requestAnimationFrame(() => {
                setTimeout(runPostRender, 250);
              });
            },
            enable_content_collection_modal: false,
            product: {
              name: this.productInfo.title,
              url: `https://${location.host}${location.pathname}`,
              image_url: this.productInfo.featured_image,
              description: this.productInfo.description,
              category_name: this.productInfo.type,
              upc: '',
              brand_name: this.productInfo.vendor,
              price: (this.productInfo.price / 100).toFixed(2),
              in_stock: this.productInfo.available,
              variants: variantsData,
            },
            subject: {
              '@context': 'https://schema.org',
              '@type': 'Product',
              name: this.productInfo.title,
              description: this.productInfo.description,
              url: `https://${location.host}${location.pathname}`,
              image: this.productInfo.featured_image,
              sku: this.productInfo.variants[0].sku,
              brand: {
                '@type': 'Brand',
                name: this.productInfo.vendor,
              },
              offers: {
                '@type': 'Offer',
                priceCurrency: 'CAD',
                url: `https://${location.host}${location.pathname}`,
                price: (this.productInfo.price / 100).toFixed(2),
                priceValidUntil: new Date(Date.now() + 31536000000)
                  .toISOString()
                  .split('T')[0],
                availability: this.productInfo.available
                  ? 'https://schema.org/InStock'
                  : 'https://schema.org/OutOfStock',
              },
              additionalProperty: [
                {
                  '@type': 'PropertyValue',
                  propertyID: 'item_group_id',
                  value: this.productInfo.id,
                },
              ],
            },
            components: {
              ReviewSnippet:
                window.innerWidth < 750
                  ? 'PowerReviewsPDPMobile'
                  : 'PowerReviewsPDP',
              ReviewAISummary: 'PowerReviewsAISummary',
              ReviewImageDisplay: 'PowerReviewsImageDisplay',
              ReviewSnapshot: 'PowerReviewsSnapshot',
              ReviewList: 'PowerReviewsList',
            },
          });
        }
      }

      /**
       * Section fetch returns fresh `product` JSON; keep in sync for PowerReviews and scripts
       * that read this.productInfo after a variant change.
       * @returns {object|null} Parsed product from the fetched section, or null if missing/invalid.
       */
      syncProductInfoFromSectionHtml(html) {
        try {
          const remote =
            html.getElementById(this.id) ||
            html.querySelector(
              `product-info[data-section="${this.dataset.section}"]`
            );

          if (!remote) {
            console.error(
              '[product-info] syncProductInfoFromSectionHtml: product-info node not found in section HTML'
            );
            return null;
          }

          const script = remote.querySelector?.('script[data-product-info]');
          if (!script?.textContent) {
            console.error(
              '[product-info] syncProductInfoFromSectionHtml: missing script[data-product-info]'
            );
            return null;
          }

          let next;
          try {
            next = JSON.parse(script.textContent);
          } catch (parseError) {
            console.error(
              '[product-info] syncProductInfoFromSectionHtml: invalid JSON in script[data-product-info]',
              parseError
            );
            return null;
          }

          this.productInfo = next;

          const localScript = this.querySelector('script[data-product-info]');
          if (localScript) {
            localScript.textContent = script.textContent;
          }
          if (remote.dataset?.productId != null) {
            this.dataset.productId = remote.dataset.productId;
          }

          return next;
        } catch (error) {
          console.error(
            '[product-info] syncProductInfoFromSectionHtml: unexpected error',
            error
          );
          return null;
        }
      }

      /** Re-run PowerReviews after variant-driven DOM sync (snippets + split review containers). */
      reinitializePowerReviewsIfNeeded() {
        if (!window.pwr) return;

        this.reviews = this.querySelector('#PowerReviewsPDP');
        const hasReviewsUi =
          this.reviews ||
          this.querySelector('#PowerReviewsPDPMobile') ||
          this.querySelector('#PowerReviewsDisplayRoot') ||
          this.querySelector('#PowerReviewsSnapshot') ||
          this.querySelector('#PowerReviewDisplay');
        if (!hasReviewsUi) return;

        try {
          document
            .getElementById('PowerReviewsSnapshot')
            ?.classList.remove('jd-fit-rating--ready');
          document
            .getElementById('PowerReviewsDisplayRoot')
            ?.classList.remove(
              'jd-fit-rating--ready',
              'power-reviews-display--empty'
            );
          document.getElementById('PowerReviewDisplay')?.classList.remove(
            'jd-fit-rating--ready'
          );
          [
            'PowerReviewsAISummary',
            'PowerReviewsImageDisplay',
            'PowerReviewsFitRating',
            'PowerReviewsList',
          ].forEach((id) => {
            const el = document.getElementById(id);
            if (!el) return;
            el.hidden = false;
            el.removeAttribute('aria-hidden');
            el.classList.remove(
              'power-reviews-slot--hidden',
              'power-reviews-slot--collapsed'
            );
          });
          const fitHost = document.getElementById('PowerReviewsFitRating');
          if (fitHost) fitHost.innerHTML = '';
          this.initializeReviews();
        } catch (error) {
          console.error(
            '[product-info] reinitializePowerReviewsIfNeeded: initializeReviews failed',
            error
          );
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.onVariantUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll('.scroll-trigger')
            .forEach((element) =>
              element.classList.add('scroll-trigger--cancel')
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleGroupSwatchChange(target) {
        if (!this.contains(target)) return;

        if (window.theme.dynamic_yield_enabled && DynamicYield) {
          DynamicYield.triggerSPA(
            this.dataset.productSku,
            this.dataset.productHandle
          );
          DynamicYield.updateRecomendationContext(this.dataset.productSku);
        }

        const swatch = target.closest('.swatch');

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          swatch.dataset.productUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = false;
        const shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            [],
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: this.handleUpdateProductInfo(productUrl),
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        if (window.theme.dynamic_yield_enabled && DynamicYield) {
          DynamicYield.changeAttribute(target.dataset.optionName, target.value);
        }

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;

        //const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldSwapProduct = false;
        const shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : 'product-info';

          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML =
              html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          const productInfoRoot = updateFullPage
            ? document.querySelector("product-info[id^='MainProduct']")
            : this;
          productInfoRoot?.syncProductInfoFromSectionHtml(html);
          productInfoRoot?.reinitializePowerReviewsIfNeeded();
          productInfoRoot?.syncWishlistAfterProductUpdate(
            html,
            productUrl,
            variant
          );
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.warn('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          'variant-selects [data-selected-variant]'
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));

              if (id === 'ProductTitle') {
                const mobileDestination = document.querySelector(
                  ".product__mobile [id*='ProductTitle']"
                );
                if (mobileDestination) {
                  mobileDestination.innerHTML = source.innerHTML;
                }
              }

              if (id === 'ProductPrice') {
                const mobileDestination = document.querySelector(
                  ".product__mobile [id*='ProductPrice']"
                );
                if (mobileDestination) {
                  mobileDestination.innerHTML = source.innerHTML;
                }
              }

              if (id === 'Sku') {
                const mobileDestination = document.querySelector(
                  ".product__mobile [id*='Sku']"
                );
                if (mobileDestination) {
                  mobileDestination.innerHTML = source.innerHTML;
                }
              }
            } else {
              const sources = html.querySelectorAll(
                `[id*="${id}-${this.sectionId}-"]`
              );

              sources.forEach((source) => {
                const destinations = this.querySelector(`#${source.id}`);

                if (source && destinations) {
                  destinations.innerHTML = source.innerHTML;
                  destinations.classList.toggle('hidden', shouldHide(source));
                }
              });
            }
          };

          updateSourceFromDestination('ProductMediaWrapper');
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);

          updateSourceFromDestination('ProductLimitedEditionLabel');
          updateSourceFromDestination('ProductCoreColoursLabel');

          updateSourceFromDestination('ProductTitle');
          updateSourceFromDestination('ProductPrice');
          updateSourceFromDestination('Sku', ({ classList }) =>
            classList.contains('hidden')
          );
          updateSourceFromDestination(
            'Inventory',
            ({ innerText }) => innerText === ''
          );

          updateSourceFromDestination('ProductText', ({ classList }) =>
            classList.contains('hidden')
          );

          updateSourceFromDestination('ProductBuyButtons');

          updateSourceFromDestination('ProductSticky');

          this.syncProductInfoFromSectionHtml(html);
          this.dataset.url = productUrl;
          if (this.productInfo?.handle) {
            this.dataset.pdpSection = this.productInfo.handle;
          }
          this.reinitializePowerReviewsIfNeeded();
          this.syncWishlistAfterProductUpdate(html, productUrl, variant);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      /**
       * Colour swatches are separate products. The wishlist button is not in the
       * patched DOM list, so copy the fetched button onto PDP (and mobile) and
       * ask Swym to re-read product/variant ids.
       */
      syncWishlistAfterProductUpdate(html, productUrl, variant) {
        if (!window.theme?.wishlist_enabled) return;

        const sourceButton = html.querySelector(
          '.product__wishlist .swym__button[data-swaction="addToWishlist"]'
        );
        const buttons = [
          ...this.querySelectorAll(
            '.product__wishlist .swym__button[data-swaction="addToWishlist"]'
          ),
          ...document.querySelectorAll(
            '.product__mobile .product__wishlist .swym__button[data-swaction="addToWishlist"]'
          ),
        ];

        if (sourceButton && buttons.length) {
          buttons.forEach((button) => {
            button.replaceWith(sourceButton.cloneNode(true));
          });
        } else {
          const productId = this.dataset.productId || this.productInfo?.id;
          const variantId = variant?.id;
          const url = productUrl?.startsWith('http')
            ? productUrl
            : `${location.origin}${productUrl || ''}`;

          buttons.forEach((button) => {
            [...button.classList].forEach((cls) => {
              if (cls.startsWith('product_')) button.classList.remove(cls);
            });
            if (productId) {
              button.classList.add(`product_${productId}`);
              button.dataset.productId = String(productId);
            }
            if (variantId) button.dataset.variantId = String(variantId);
            if (url) button.dataset.productUrl = url;
            button.classList.remove('swym-added', 'swym-loaded');
          });
        }

        this.refreshSwymProductContext(productUrl, variant);
        document.dispatchEvent(new CustomEvent('swym:variant-changed'));
      }

      refreshSwymProductContext(productUrl, variant) {
        const product = this.productInfo;
        if (!product) return;

        window.SwymProductInfo = window.SwymProductInfo || {};
        window.SwymProductInfo.product = product;
        window.SwymProductInfo.variants = product.variants || [];
        if (variant?.id) {
          window.SwymProductInfo.currentVariant = variant.id;
        }

        const du = productUrl?.startsWith('http')
          ? productUrl
          : `${location.origin}${productUrl || product.url || ''}`;

        window.SwymProductVariants = window.SwymProductVariants || {};
        (product.variants || []).forEach((v) => {
          window.SwymProductVariants[v.id] = {
            empi: product.id,
            epi: v.id,
            dt: product.title,
            du,
            pr: (v.price || 0) / 100,
            ct: product.type,
          };
        });

        if (
          typeof window.triggerSwymVariantEvent === 'function' &&
          variant?.id
        ) {
          window.triggerSwymVariantEvent(variant.id);
        }
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState(
          {},
          '',
          `${url}${variantId ? `?variant=${variantId}` : ''}`
        );
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}





